import { render, staticRenderFns } from "./DetailClassPrakerja.vue?vue&type=template&id=b9fd7390&scoped=true&"
import script from "./DetailClassPrakerja.vue?vue&type=script&lang=js&"
export * from "./DetailClassPrakerja.vue?vue&type=script&lang=js&"
import style0 from "./DetailClassPrakerja.vue?vue&type=style&index=0&id=b9fd7390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd7390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
